import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';

import { SnCommonModule } from '@lib/common';
import { TranslationModule } from '@lib/translation/translation.module';
import { SnButtonModule } from '@lib/ui/button';
import { SnIconModule } from '@lib/ui/icon';
import { SnUsersModule } from '@lib/users';

import { NotificationFormComponent } from './components';

@NgModule({
  imports: [
    // Angular
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    // Material
    MatFormFieldModule,
    MatSelectModule,
    // Libs
    SnCommonModule,
    SnUsersModule,
    SnIconModule,
    SnButtonModule,
    TranslationModule,
  ],
  declarations: [NotificationFormComponent],
  exports: [NotificationFormComponent],
})
export class SnNotificationUsersModule {}
